import React from "react";
import PropTypes from "prop-types";
import { CreateContainer } from "./ContainerCreate";
import { getMessageBoardToday } from "../api/getMessageBoard";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

class MessageBoardTodayContainer extends React.Component {
  componentDidMount() {
    const { page } = this.props;
    this.props.request(page);
  }
  componentWillReceiveProps(nextProps) {
    const { page: nextPage } = nextProps;
    const { page } = this.props;
    if (nextPage !== page) {
      this.props.request(nextPage);
    }
  }
  render = () => {
    const { data, loading, failure, render } = this.props;
    const topics = (data && data.data) || [];
    if (loading) {
      return (
        <SkeletonTheme color="#ccc" highlightColor="#ddd">
          <Skeleton count={6} />
        </SkeletonTheme>
      );
    }
    // if (!loading && topics.length === 0) {
    //   return null;
    // }
    return render({ topics, loading, failure });
  };
}

export default CreateContainer(getMessageBoardToday, MessageBoardTodayContainer);
